export default "__VITE_ASSET__fjXiWZgz__"